<script setup>
defineProps({
  items: {
    type: Array,
    required: true,
  },
})
</script>

<template>
  <nav class="breadcrumbs" aria-label="Хлібні крихти">
    <ol class="breadcrumbs__list">
      <li v-for="(item, index) in items" :key="`${item.label}-${index}`" class="breadcrumbs__item">
        <NuxtLink
          v-if="item.to && index < items.length - 1"
          :to="item.to"
          class="breadcrumbs__link"
        >
          {{ item.label }}
        </NuxtLink>
        <span v-else class="breadcrumbs__current" aria-current="page">
          {{ item.label }}
        </span>
        <span v-if="index < items.length - 1" class="breadcrumbs__separator">/</span>
      </li>
    </ol>
  </nav>
</template>

<style lang="scss" scoped>
.breadcrumbs {
  color: #0f0f0f;
  font-size: 0.9em;
  line-height: 1.4;
}

.breadcrumbs__list {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.45em;
  list-style: none;
  margin: 0;
  padding: 0;
}

.breadcrumbs__item {
  align-items: center;
  display: inline-flex;
  gap: 0.45em;
}

.breadcrumbs__link {
  color: inherit;
  opacity: 0.68;
  text-decoration: none;
  transition: opacity 0.2s ease-in-out;
}

.breadcrumbs__link:hover {
  opacity: 1;
}

.breadcrumbs__current {
  color: inherit;
  opacity: 0.92;
}

.breadcrumbs__separator {
  opacity: 0.35;
}
</style>
